import { useState, useCallback } from 'react';

interface UseInstanceSelectionResult {
  selectedInstanceIds: string[];
  handleSelectionChange: (ids: string[]) => void;
}

export const useInstanceSelection = (): UseInstanceSelectionResult => {
  const [selectedInstanceIds, setSelectedInstanceIds] = useState<string[]>([]);

  const handleSelectionChange = useCallback((ids: string[]) => {
    setSelectedInstanceIds(ids);
  }, []);

  return { selectedInstanceIds, handleSelectionChange };
};
